import FormItem from '@/src/components/Antd/FormItem/FormItem';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { PlusOutlined } from '@ant-design/icons';
import { Select as SelectAntd } from 'antd';
import React from 'react';
import { EnumFormItemStatus } from 'src/types/common/validation';
import GlobalButton from '../Button/Button';
import SearchSelect from './SearchSelect/SearchSelect';
import css from './Select.less';
import { generateOptions } from './tools';
const { Option, OptGroup } = SelectAntd;

export { SearchSelect, generateOptions };
// interface IProps {
//   optionsList?: OptionsList[];
//   rightBtn?: RightBtn;
//   size?;
//   value?;
//   onChange?;
//   status?: EnumFormItemStatus;
//   help?: string | ReactNode;
//   optionsGroupList?: OptionsGroupList[];
//   error?: boolean;
// }
export interface OptionsList {
  label: string | number;
  value: string | number;
}
export interface OptionsGroupList {
  key?: string;
  label: string;
  children: OptionsList[];
}
// interface RightBtn {
//   type: 'add' | undefined;
//   clickFun: Function;
// }

const Select = (props) => {
  const {
    optionsList,
    optionsGroupList,
    rightBtn,
    size,
    value,
    onChange,
    // status,
    help,
    error,
    selectClassName,
    dropdownClassName,
    placeholder,
    children,
    formProps,
    ...rest
  } = props;
  const { type, clickFun, disabled, addButtonClassName } = rightBtn || {};
  const options = () => {
    if (optionsList) {
      return optionsList.map((item, index) => (
        <Option
          key={item.value}
          value={item.value}
          disabled={item.disabled}
          {...Object.keys(item || {}).reduce((pre, key) => {
            return { ...pre, [`data-${key}`]: item[key] };
          }, {})}>
          {item.label}
        </Option>
      ));
    }
    if (optionsGroupList) {
      return optionsGroupList.map((group, index) => {
        return (
          <OptGroup label={group.label} key={index}>
            {(group.children || []).map((item, index) => (
              <Option
                key={item.value}
                value={item.value}
                {...Object.keys(item || {}).reduce((pre, key) => {
                  return { ...pre, [`data-${key}`]: item[key] };
                }, {})}>
                {item.label}
              </Option>
            ))}
          </OptGroup>
        );
      });
    }
    return null;
  };
  return (
    <FormItem
      {...(error && {
        status: EnumFormItemStatus.error,
        help: help || getI18nFromGeneral('general.antd.DatePicker.item_help'),
      })}
      {...formProps}>
      <div className={css.selectContain}>
        <SelectAntd
          placeholder={placeholder}
          size={size}
          value={value}
          onChange={onChange}
          className={`${css.select} ${selectClassName || ''}`}
          dropdownClassName={`${css.dropdown} ${dropdownClassName || ''}`}
          {...rest}>
          {children || options()}
        </SelectAntd>
        {rightBtn && type === 'add' && (
          <GlobalButton
            className={`${addButtonClassName} ${css.addButton}`}
            size={size}
            disabled={disabled}
            onClick={() => clickFun()}>
            <PlusOutlined />
          </GlobalButton>
        )}
      </div>
    </FormItem>
  );
};
Select.Option = Option;
export default Select;
